import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { throwError } from "rxjs";
import { ApiService } from './api.service';
import { AuthenticationService } from '../services/authentication.service';
import { RESTClientConfig } from '../config';
import { AccessTokenMissingException } from '../model/access-token-missing.exception';
import * as i0 from "@angular/core";
import * as i1 from "../services/authentication.service";
import * as i2 from "../config";
import * as i3 from "@angular/common/http";
export class AuthenticatedApiService extends ApiService {
    constructor(auth, config, http) {
        super(http, config);
        this.auth = auth;
    }
    request(url, options = {}) {
        options.headers = options.headers || {};
        let access_token = this.auth.getAccessToken();
        if (!access_token)
            return throwError(new AccessTokenMissingException());
        options.headers['Authorization'] = access_token;
        return super.request(url, options);
    }
}
AuthenticatedApiService.ɵfac = function AuthenticatedApiService_Factory(t) { return new (t || AuthenticatedApiService)(i0.ɵɵinject(i1.AuthenticationService), i0.ɵɵinject(i2.RESTClientConfig), i0.ɵɵinject(i3.HttpClient)); };
AuthenticatedApiService.ɵprov = i0.ɵɵdefineInjectable({ token: AuthenticatedApiService, factory: AuthenticatedApiService.ɵfac });
(function () { i0.ɵsetClassMetadata(AuthenticatedApiService, [{
        type: Injectable
    }], function () { return [{ type: i1.AuthenticationService }, { type: i2.RESTClientConfig }, { type: i3.HttpClient }]; }, null); })();
//# sourceMappingURL=authenticated-api.service.js.map